import { lazyRouteComponent } from "@tanstack/react-router";
import { Flame } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const KINDS = ["all", "index", "stock"] as const;
export const PERIODS = ["today", "5d", "20d"] as const;
export const SIDES = ["both", "CE", "PE"] as const;
export const SORTS = ["gainers", "losers", "oi_up", "volume"] as const;

export interface OptionsSearch {
  kind: (typeof KINDS)[number];
  period: (typeof PERIODS)[number];
  side: (typeof SIDES)[number];
  sort: (typeof SORTS)[number];
  /** Underlying filter, exact symbol (e.g. NIFTY, RELIANCE). */
  u?: string;
}

function pick<T extends readonly string[]>(list: T, v: unknown, fallback: T[number]): T[number] {
  return list.includes(v as string) ? (v as T[number]) : fallback;
}

export function parseOptionsSearch(s: Record<string, unknown>): OptionsSearch {
  const u = typeof s.u === "string" && /^[A-Za-z0-9&_-]{1,30}$/.test(s.u) ? s.u.toUpperCase() : undefined;
  return {
    kind: pick(KINDS, s.kind, "all"),
    period: pick(PERIODS, s.period, "today"),
    side: pick(SIDES, s.side, "both"),
    sort: pick(SORTS, s.sort, "gainers"),
    ...(u ? { u } : {}),
  };
}

export const pages: PageDef[] = [
  {
    path: "/app/options",
    proOnly: true,
    title: "Options movers",
    component: lazyRouteComponent(() => import("./OptionsPage"), "OptionsPage"),
    nav: { label: "Options movers", icon: Flame, group: "Premium", order: 30 },
    validateSearch: parseOptionsSearch,
  },
];
